import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { EditActionContext } from "./EditActionContext";

function useUpdate() {
  const { element, setBackendFormErrors } = useContext(EditActionContext);
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    // Mapear delivery_note_lines de vuelta a invoice_lines antes de enviar
    const dataToSend = { ...element };
    if (dataToSend.delivery_note_lines) {
      dataToSend.invoice_lines = dataToSend.delivery_note_lines;
      delete dataToSend.delivery_note_lines;
    }
    if (dataToSend.delivery_note_type_id) {
      dataToSend.invoice_type_id = dataToSend.delivery_note_type_id;
      delete dataToSend.delivery_note_type_id;
    }
    
    update("invoices", element.id, dataToSend)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useUpdate;
